import React from 'react';
import { Scissors, Sparkles, Heart, Palette } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

const Services = () => {
  const services = [
    {
      icon: Scissors,
      title: 'Hair',
      description: 'Professional hair services for every style',
      items: ['Haircuts & Styling', 'Hair Coloring', 'Hair Treatments', 'Keratin & Smoothing'],
      color: 'from-[#61525a] to-[#736c64]',
      iconBg: 'bg-[#61525a]',
    },
    {
      icon: Sparkles,
      title: 'Nails',
      description: 'Exquisite nail art and care',
      items: ['Manicure & Pedicure', 'Nail Art', 'Gel Polish', 'Nail Extensions'],
      color: 'from-[#fad24b] to-[#ff8c19]',
      iconBg: 'bg-[#fad24b]',
    },
    {
      icon: Heart,
      title: 'Skincare',
      description: 'Rejuvenate and glow treatments',
      items: ['Facials', 'Cleanup', 'Glow Treatments', 'Anti-Aging Care'],
      color: 'from-[#3dd3ee] to-[#5f9dff]',
      iconBg: 'bg-[#3dd3ee]',
    },
    {
      icon: Palette,
      title: 'Beauty',
      description: 'Complete makeover services',
      items: ['Bridal Makeup', 'Party Makeup', 'Threading', 'Waxing'],
      color: 'from-[#b4dc19] to-[#78286e]',
      iconBg: 'bg-[#b4dc19]',
    },
  ];

  return (
    <section id="services" className="py-16 md:py-24 bg-gradient-to-br from-white to-[#f7f5f2]">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Comprehensive beauty solutions tailored to your needs. From hair to nails, skincare to makeup, we've got you covered.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card
                key={index}
                className="border-none shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden group"
              >
                {/* Gradient header */}
                <div className={`h-2 bg-gradient-to-r ${service.color}`} />
                
                <CardHeader className="text-center pb-4">
                  <div className={`w-16 h-16 mx-auto mb-4 ${service.iconBg} rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <CardTitle className="text-2xl mb-2">{service.title}</CardTitle>
                  <CardDescription className="text-base">{service.description}</CardDescription>
                </CardHeader>
                
                <CardContent>
                  <ul className="space-y-2">
                    {service.items.map((item, idx) => (
                      <li key={idx} className="flex items-start space-x-2 text-sm text-gray-700">
                        <span className="text-accent-primary mt-1">•</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="mt-6 pt-4 border-t border-gray-100">
                    <p className="text-sm text-gray-500 text-center">
                      Starting from <span className="font-semibold text-accent-primary">₹299</span>
                    </p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12">
          <p className="text-lg text-gray-700 mb-4">
            Need a custom package or have questions?
          </p>
          <a
            href="tel:+919955885574"
            className="inline-block bg-accent-primary hover:bg-accent-primary-dark text-white font-semibold px-8 py-3 rounded-lg transition-all duration-300 hover:shadow-lg"
          >
            Call us at +91 99558 85574
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;